export const WS_ASSETS_REGEXP = /[^/\w]\/ws\/[-\w/.]+/gm;
export const WS_ASSETS_ERROR_MESSAGE =
  'Internal website assets can not be referenced in custom code.';
